import { autoinject } from "aurelia-framework";
import { Structure } from "../../models/structure";
import { Location } from "../../models/location";
import { Store } from "aurelia-store";
import { IState } from "../../store/state";
import { Subscription } from "rxjs";
import * as Linq from "linq-es2015";
import { Zone } from "../../models/zone";
import { I18N } from "aurelia-i18n";
import { updateStructure } from "../../store/actions/structure-actions";
import { dispatchify } from "aurelia-store";
import * as State from "../../store/state";
import { MdToastService } from "aurelia-materialize-bridge";
import { Api } from "../../services/api";

@autoinject
export class StructureDetail {
	applicationState: IState;

	structure: Structure;
	zone: Zone;
	location: Location;

	private locations: Location[];
	private subscription: Subscription;
	private params: any;

	active: boolean = false;
	message: string;

	constructor(private store: Store<IState>, private i18n: I18N, private toastService: MdToastService, private api: Api) {
		this.message = i18n.tr("adding-location");
	}

	selectChanged(status: any) {
		this.active = true;
		dispatchify<IState, any>(updateStructure)(this.structure, this.location.id, this.zone.id).then(state => {
			const s = state;
			this.toastService.show(this.i18n.tr("data-saved"),
				4000,
				"rounded blue");
		});
		this.active = false;
	}

	async bind(bindingContext: any, overrideContext: any) {
		this.subscription = this.store.state.subscribe(async (state) => {
			this.applicationState = state;
			this.locations = state.locationState.selectedLocations;
			this.structure = await this.getStructure(this.params);
		});

	}

	unbind() {
		this.subscription.unsubscribe();
	}

	activate(params: any) {
		this.params = params;
	}

	async getStructure(params: any): Promise<Structure> {
		this.location = Linq.AsEnumerable(this.locations).FirstOrDefault(l => l.id === params.locationId);
		if (this.location == null) {
			return null;
		}
		this.zone = Linq.AsEnumerable(this.location.zones).FirstOrDefault(zone => zone.id === params.zoneId);
		if (this.zone == null) {
			return null;
		}

		const structure = Linq.AsEnumerable(this.zone.structures).FirstOrDefault(s => s.id === params.structureId);
		if (structure == null) {
			return null;
		}
		return structure;
	}
}
